import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FiscalEmissionPoint } from '../models/fiscal-emission-point';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root'
})
export class FiscalEmissionPointService {
  private url = `${environment.url}/fiscalEmissionPoints`;
  constructor(private readonly http: HttpClient) { }

  readFiscalEmissionPoints(registerCode: string, salesOrg: string) {
    const params = new HttpParams()
      .set("registerCode", registerCode)
      .set("salesOrg", salesOrg);

    return this.http.get<ResponseModel<Paging<Array<FiscalEmissionPoint>>>>(this.url, { params })
  }
}
